import React, { useState } from "react";

// Components
import { Plus } from 'react-feather';
import { Box, Button } from 'react-bulma-components';
import StageColumn from './StageColumn';

// Constants & actions
import { STAGES } from "shared/enums";
import { useAuthUser } from 'shared/state';

// Styles
import styles from './Leads.module.scss';

const LeadsBoard = ({ list, onMoveLead, onAddLead, onSelectLead }) => {
    const { user } = useAuthUser();
    const [myLeads, moveMyLead] = useState({ ...list });

    const handleMoveMyLead = (from, to) => {
        const { item, columnIndex: fromColumnIndex, index } = from;
        const { columnIndex: toStage } = to;
        const newLeadObj = { id: item.id, stage: toStage, from: fromColumnIndex, item: item};

        onMoveLead(newLeadObj);
    };

    return (
        <div className={ styles.leadsList }>
            { Object.entries(STAGES).map(([stage, label], i) => {
                const columnIndex = stage;
                const currStageList = list[stage];
                const propsToColumn = { columnIndex, handleMoveMyLead, onSelectLead };

                return (
                    <div className={ `${ styles.lead } ${ styles[stage] }` } key={i}>
                        <header className={ styles.header }>
                            <h3>{ label }</h3>
                            <Button size="small" onClick={ ()=> onAddLead(stage) }>
                                <Plus size={ 20 } strokeWidth={2} />
                            </Button>
                        </header>

                        <StageColumn
                            key={`column ${columnIndex}`}
                            {...propsToColumn}
                            items={ currStageList }
                        />
                    </div>
                )
                })
            }
        </div>
    )
}

export default LeadsBoard;
